import axios from "@/plugins/axios";

async function saveCheck(json, name, nameQuestion) {
  return axios.post("?Mode=General&Function=SaveCheck", {
    Json: JSON.stringify(json),
    Name: name,
    NameQuestion: nameQuestion,
  });
}

export { saveCheck };
